import { from, Observable, switchMap } from 'rxjs';

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  private readonly authService = inject(AuthService);
  private readonly transloco = inject(TranslocoService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return from(this.authService.getAccessToken()).pipe(
      switchMap((token) => {
        const headers: Record<string, string> = {
          'x-channel': environment['x-channel'],
          'X-Lang': this.transloco.getActiveLang(),
          ...(token && { Authorization: `Bearer ${token}` }),
        };
        return next.handle(request.clone({ setHeaders: headers }));
      }),
    );
  }
}
